export const VIDEO_OPTS = {
    width: 970,
    height: 546,
    playerVars: {
        autoplay: 1,
        rel: 0,
        showinfo: 0
    }
};
